import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseAuthComponent } from '../../abstract-components/base-auth.component';

@Component({
  selector: 'reset-password',
  standalone: false,
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetPasswordComponent extends BaseAuthComponent {
  title = 'Réinitialisation de mot de passe';
  description =
    'Entrez votre adresse e‑mail pour réinitialiser votre mot de passe.';
}
